module.exports = __webpack_public_path__ + "static/media/trend-google-rev-description.03af1524.jpg";